import { ShareSettingsProptypes } from "../../components/Cards/CardComponents/CardSettings";


export const shareSettingsOption = (shareSettingsConfig: ShareSettingsProptypes) => {
  return { type: 'SHOW_SCRAP_SETTINGS',payload:shareSettingsConfig}
}
